import { render, staticRenderFns } from "./CallLogs.vue?vue&type=template&id=37978f5e"
import script from "./CallLogs.vue?vue&type=script&lang=ts"
export * from "./CallLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports